// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Drag: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
<path fill="currentColor" fillRule="evenodd" clipRule="evenodd" d="M7.59,18.62c1.22,0,2.21,0.99,2.21,2.21c0,1.22-0.99,2.21-2.21,2.21
	s-2.21-0.99-2.21-2.21C5.38,19.61,6.37,18.62,7.59,18.62z M16.41,18.62c1.22,0,2.21,0.99,2.21,2.21c0,1.22-0.99,2.21-2.21,2.21
	s-2.21-0.99-2.21-2.21C14.21,19.61,15.2,18.62,16.41,18.62z M7.59,9.79c1.22,0,2.21,0.99,2.21,2.21s-0.99,2.21-2.21,2.21
	S5.38,13.22,5.38,12S6.37,9.79,7.59,9.79z M16.41,9.79c1.22,0,2.21,0.99,2.21,2.21s-0.99,2.21-2.21,2.21s-2.21-0.99-2.21-2.21
	S15.2,9.79,16.41,9.79z M7.59,0.96c1.22,0,2.21,0.99,2.21,2.21S8.8,5.38,7.59,5.38S5.38,4.39,5.38,3.17S6.37,0.96,7.59,0.96z
	 M16.41,0.96c1.22,0,2.21,0.99,2.21,2.21s-0.99,2.21-2.21,2.21s-2.21-0.99-2.21-2.21S15.2,0.96,16.41,0.96z"/>
</svg>;
};

export default React.memo(Drag);
